import React, { useEffect, useState, useRef, useCallback } from 'react';
import axios from 'axios';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import { fetchUsersList, fetchFiltersList } from "../../components/services/Service";
import './UsersList.css'
import { Modal } from 'react-bootstrap';
import AddMember from '../addmember/AddMember';
import SearchExternalMember from '../members/SearchExternalMember';



const UsersList = ({ onUserClick }) => {
    const [defaultFilterObject, setDefaultFilterObject] = useState({
        "label": "All",
        "filterId": "",
        "filterType": "all",
        "count": 0
    })
    const [filtersList, setFiltersList] = useState([]);
    const [showFiltersList, setShowFiltersList] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState(defaultFilterObject);
    const [selectParentFilter, setSelectParentFilter] = useState("");
    const [appliedFilter, setAppliedFilter] = useState({});

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [query, setQuery] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [users, setUsers] = useState([]);
    const [usercount, setUserCount] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [callfetchuser, setCallfetchuser] = useState(false);

    const observer = useRef();
    const lastUserElementRef = useCallback(node => {
        if (loading) return
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setPageNumber(prevPageNumber => prevPageNumber + 1)
            }
        })
        if (node) observer.current.observe(node)
    }, [loading, hasMore]);

    useEffect(() => {
        setUsers([])
    }, [query])

    useEffect(() => {
        setLoading(true);
        setError(false);
        getUsersList(appliedFilter, query, pageNumber)
    }, [query, appliedFilter, pageNumber, callfetchuser]);

    const getUsersList = async (appliedFilter, query, pageNumber) => {
        const request = axios.CancelToken.source()
        let ct = {
            cancelToken: request.token
        }
        await fetchUsersList(appliedFilter, query, pageNumber, ct)
            .then((result) => {
                if (result.data.data.users) {
                    setUserCount(result.data.data.userCount)

                    /*if (Object.keys(appliedFilter).length === 0 && appliedFilter.constructor === Object) {
                        let dfo = { ...defaultFilterObject }
                        dfo.count = result.data.data.userCount
                        if (users.length === 0) {
                            setDefaultFilterObject(dfo)
                        }
                    }*/

                    /*setUsers(prevUsers => {
                        return [...prevUsers, ...result.data.data.users]
                    })*/

                    setUsers(prevUsers => {
                        const newUsers = (result.data.data.users).filter(user =>
                            !prevUsers.some(existingUser => existingUser.userId === user.userId)
                        );
                        return [...prevUsers, ...newUsers];
                    });

                    if (result.data.data.users.length > 0) setHasMore(true);
                    else setHasMore(false);
                    setLoading(false);
                }
            }).catch(function (error) {
                if (axios.isCancel(error)) return true;
                setError(true);
            });
        return () => request.cancel()
    }

    function handleSearch(e) {
        setQuery(e.target.value);
        setPageNumber(1);
    }

    const handleFilterContainerClick = async () => {
        if (filtersList.length <= 0) {
            const request = axios.CancelToken.source()
            let ct = {
                cancelToken: request.token
            }
            await fetchFiltersList(ct)
                .then((response) => {
                    let fl = [];
                    fl.push(defaultFilterObject)
                    fl.push(...response.data.data.filters)
                    setFiltersList(fl)
                    setShowFiltersList(true);
                }).catch(function (error) {
                    console.log(error);
                });
            return () => request.cancel()
        } else {
            setShowFiltersList(!showFiltersList)
        }
    }

    const handleParentFilter = (label) => {
        if (selectParentFilter === label) {
            setSelectParentFilter("")
        } else {
            setSelectParentFilter(label)
        }
    }

    const handleAppliedFilter = (filter) => {
        setPageNumber(1)
        setDefaultFilterObject(filter)
        setShowFiltersList(!showFiltersList)
        setAppliedFilter(filter);
        setUsers([])
    }


    const handleShowMemberProfileDetailsModal = () => {
        setShowModal(true);
    }

    const [showSearchExternalMemberModal, setShowSearchExternalMemberModal] = useState(false);
    const closeSearchExternalMemberModal = () => {
        setShowSearchExternalMemberModal(false);
    }

    return (
        <>
            <div className="userslist">
                <div>
                    <div className='row align-items-center mb-2 d-flex'>
                        <div className='col-auto pe-2'>
                            <h2 className='card-member-title'>Members</h2>
                        </div>
                        <div className='col px-0'>
                            <Link class="badge rounded-pill btn btn-outline-secondary add-new-member-btn" onClick={handleShowMemberProfileDetailsModal}>
                                Add Member
                            </Link>
                        </div>
                        <div className='col text-end ps-0'>
                            <span class="badge rounded-pill btn btn-outline-secondary">
                                <span className='gray-small hand-cursor' onClick={() => {
                                    if (users.length > 0 && query !== "") setUsers([]);
                                    if (query !== "") setQuery("");
                                    if (pageNumber !== 1) setPageNumber(1);
                                }}>View All</span>
                                <span className='orange-small ps-2'>{usercount}</span>
                            </span>

                        </div>
                    </div>

                </div>
                <div className='row align-items-center'>
                    <div className='col'>
                        <div className="search mb-0">
                            <i className="fa fa-search" aria-hidden="true"></i>
                            <input type="text" placeholder='Search' value={query} onChange={handleSearch}></input>
                        </div>
                    </div>
                    <div className='col-auto border-start'>
                        <span class="badge rounded-pill btn btn-outline-secondary" onClick={() => setShowSearchExternalMemberModal(true)}>
                            <i className="fa fa-search all-members gray-small hand-cursor ms-0" aria-hidden="true" ></i>
                        </span>
                    </div>
                </div>


                <div className='userlistname'>
                    {/* <div className="no-data-box">
                        <h5>No members assigned yet.</h5>
                        <h6 className='card-title1 '>Your members will be listed here.</h6>
                </div> */}
                    {
                        users.map((user, index) => {
                            if (users.length === index + 1) {
                                return <Row key={index} ref={lastUserElementRef} className='align-items-center mb-2'>
                                    <div className="col-4 col-md-auto">
                                        <Link to={'/members/' + encodeURIComponent(user.userId, "UTF-8")} className='name' onClick={() => onUserClick({ userId: user.userId, name: user.memberName })}>
                                            <img src={user.imageUrl} alt={user.memberName} className="profile-img"></img>
                                        </Link>
                                    </div>
                                    <div className="col col-md ps-0">
                                        <Link to={'/members/' + encodeURIComponent(user.userId, "UTF-8")} className='name' onClick={() => onUserClick({ userId: user.userId, name: user.memberName })}>{user.memberName}</Link>
                                        <h5 className='text-small'><span className=''>Membership: {user.membershipNumber}</span></h5>
                                        <h5 className='text-small'><span className=''>{user.age}</span>, <span className='ps-1'>{user.gender}</span>, <span className='ps-1'>{user.city}</span></h5>
                                        <h5 className='text-small'><span className='pe-2'>{user.condition}</span></h5>
                                        <h5 className='text-small'><span className='pe-2'>{user.pathway}</span></h5>
                                    </div>
                                </Row>
                            } else {
                                return <Row key={index} className='align-items-center mb-2'>
                                    <div className="col-4 col-md-auto">
                                        <Link to={'/members/' + encodeURIComponent(user.userId, "UTF-8")} className='name' onClick={() => onUserClick({ userId: user.userId, name: user.memberName })}>
                                            <img src={user.imageUrl} alt={user.memberName} className="profile-img"></img>
                                        </Link>
                                    </div>
                                    <div className="col col-md ps-0">
                                        <Link to={'/members/' + encodeURIComponent(user.userId, "UTF-8")} className='name' onClick={() => onUserClick({ userId: user.userId, name: user.memberName })}>{user.memberName}</Link><br />
                                        <h5 className='text-small'><span className=''>Membership: {user.membershipNumber}</span></h5>
                                        <h5 className='text-small'><span className=''>{user.age}</span>, <span className='ps-1'>{user.gender}</span>, <span className='ps-1'>{user.city}</span></h5>
                                        <h5 className='text-small'><span className='pe-2'>{user.condition}</span></h5>
                                        <h5 className='text-small'><span className='pe-2'>{user.pathway}</span></h5>
                                    </div>
                                </Row>
                            }
                        })
                    }

                </div>
            </div >

            {showModal && <AddMember status="add" heading="Add New Member" hideModal={() => {
                setShowModal(false);
                setCallfetchuser(callfetchuser + 1);
            }} />
            }

            {
                showSearchExternalMemberModal && <SearchExternalMember showSearchExternalMemberModal={showSearchExternalMemberModal} closeSearchExternalMemberModal={closeSearchExternalMemberModal} onUserClick={onUserClick} />
            }
        </>
    )
}

export default UsersList    